// src/landing/PublicChrome.jsx
// ─── Navbar, footer, WhatsApp : rendus UNE fois, par PublicSiteShell ────────
// §4-5 — La navbar V2 n'est pas une capsule : barre pleine largeur, rayon 0,
// bord inférieur discret. §15, §24 — le footer vit ici et nulle part ailleurs.
// §18-19 — WhatsApp est le seul widget flottant du site public.

import { useEffect, useState } from "react";

const WA_NUMBER = (typeof process !== "undefined" && process.env && (process.env.REACT_APP_ADMIN_WHATSAPP || process.env.VITE_ADMIN_WHATSAPP)) || "";
const WA_TEXT = "Bonjour, je souhaite en savoir plus sur VehicleIQ et VIQ.AI.";

// ── Navbar ───────────────────────────────────────────────────────────
export function PublicNavbar({ theme, onTheme, nav, onLogin, onTry }) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = previousOverflow; };
  }, [open]);
  const links = [["Produit", "product"], ["VIQ.AI", "viqai"], ["Tarification", "/tarification"], ["Ressources", "/ressources"], ["API", "/api"]];
  return (
    <header className="lv2-nav">
      <div className="lv2-wrap lv2-nav-inner">
        <button className="lv2-brand" onClick={() => nav("/")}>Vehicle<span>IQ</span></button>
        <nav className="lv2-nav-links" aria-label="Navigation principale">
          {links.map(([l, k]) => <button key={k} onClick={() => nav(k)}>{l}</button>)}
        </nav>
        <div className="lv2-nav-right">
          <button className="lv2-btn secondary sm" onClick={onLogin}>Connexion</button>
          <button className="lv2-btn primary sm" onClick={onTry}>Essayer VIQ.AI</button>
          <button className="lv2-theme" onClick={onTheme} aria-label={theme === "dark" ? "Passer en clair" : "Passer en sombre"}>
            {theme === "dark" ? "☀" : "☾"}
          </button>
          <button className="lv2-theme lv2-burger" onClick={() => setOpen(true)} aria-label="Menu">☰</button>
        </div>
      </div>
      {open && (
        <div className="lv2-drawer" role="dialog" aria-label="Menu">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span className="lv2-brand">Vehicle<span>IQ</span></span>
            <button className="lv2-theme" onClick={() => setOpen(false)} aria-label="Fermer">✕</button>
          </div>
          {links.map(([l, k]) => <button key={k} className="link" onClick={() => { setOpen(false); nav(k); }}>{l}</button>)}
          <button className="link" onClick={() => { setOpen(false); onLogin(); }}>Connexion</button>
          <button className="lv2-btn primary lg" style={{ marginTop: "1rem" }} onClick={() => { setOpen(false); onTry(); }}>Essayer VIQ.AI</button>
        </div>
      )}
    </header>
  );
}


export function PublicFooter({ nav, onLegal }) {
  const cols = [
    ["Produit", [["VIQ.AI", () => nav("viqai")], ["Tarification", () => nav("/tarification")], ["API", () => nav("/api")], ["Démonstration", () => nav("/demo")]]],
    ["Ressources", [["Ressources", () => nav("/ressources")], ["Blog", () => nav("/blog")], ["FAQ", () => nav("faq")]]],
    ["Entreprise", [["À propos", () => nav("/a-propos")], ["Contact", () => nav("contact")]]],
    // v201 — Les entrées légales sont de vraies routes publiques. Le footer ne
    // doit plus ouvrir la vieille modale : chaque lien reste partageable,
    // indexable et accessible directement au clavier comme depuis une URL.
    ["Légal", [["Mentions légales", () => nav("/mentions-legales")], ["Confidentialité", () => nav("/confidentialite")], ["CGU", () => nav("/cgu")], ["CGV", () => nav("/cgv")]]],
  ];
  return (
    <footer className="lv2-footer">
      <div className="lv2-wrap">
        <div className="lv2-footer-grid">
          <div>
            <div className="lv2-brand" style={{ cursor: "default" }}>Vehicle<span>IQ</span></div>
            <p style={{ fontSize: ".84rem", color: "var(--viq-muted)", marginTop: ".6rem", maxWidth: 260 }}>Le copilote IA des dirigeants VO</p>
          </div>
          {cols.map(([t, links]) => (
            <div key={t} className="lv2-footer-col"><h4>{t}</h4>{links.map(([l, fn]) => <button key={l} onClick={fn}>{l}</button>)}</div>
          ))}
        </div>
        <div className="lv2-footer-base">
          <span>© {new Date().getFullYear()} VehicleIQ — MKL Ingénierie et Conseil</span>
          <span>Conçu en France · Hébergé en Union européenne</span>
        </div>
      </div>
    </footer>
  );
}
export function WhatsAppButton({ number }) {
  const n = String(number || WA_NUMBER).replace(/[^\d]/g, "");
  if (!n) return null;
  return (
    <a className="lv2-wa" href={`https://wa.me/${n}?text=${encodeURIComponent(WA_TEXT)}`} target="_blank" rel="noopener noreferrer" aria-label="Nous écrire sur WhatsApp">
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5.1-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.6.8-.8 1-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.3-.4.2-.4.7-1.3.1-.2 0-.3 0-.5l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.5 4 5.2 5.2 0 0 0 3.1.6 2.6 2.6 0 0 0 1.7-1.2 2.1 2.1 0 0 0 .2-1.2c-.1-.1-.3-.2-.5-.3z"/></svg>
      <span>WhatsApp</span>
    </a>
  );
}


